import { Action } from '@ngrx/store';


export enum UserActionType {
  GET_INFO = '[User] Login',
  INFO_SUCCESS = '[User] Info Success'
}

export class UserInfo implements Action {
  readonly type = UserActionType.GET_INFO;
  constructor(public payload?: any) {}
}

export class UserInfoSuccess implements Action {
  readonly type: string = UserActionType.INFO_SUCCESS;
  constructor(public payload: any) { }
}

export type All =
| UserInfo
| UserInfoSuccess;